import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import {useAuth} from "../context/AuthProvider";
// import useRefreshToken from "../hooks/useRefreshToken";
import { useEffect, useRef } from "react";

const RequireAuth=()=>{
    const {user} = useAuth()

    return(
        user!=null
            ? 
                user.verified
                    ?<Outlet/>
                    :<Navigate to='/account'/>
            : <Navigate to='/login' state={{from: '/'}} replace/>
    )

}

export default RequireAuth